





































































import { AccountContextMixin } from '@/mixins';
import { Account } from '@/types';
import AddClientBtn from '@/account/client/AddClientBtn.vue';
import UserSubscribedAccountsList from '@/account-subscriber/UserSubscribedAccountsList.vue';
import UserUnsubscribedAccountsList from '@/account-subscriber/UserUnsubscribedAccountsList.vue';
import InfoIcon from '@/components/InfoIcon.vue';
import repository from '../account/account-repository';

interface Data {
  account: Account|null,
  task: Promise<Account>|null,
}

export default AccountContextMixin.extend({
  data(): Data {
    return {
      account: null,
      task: null,
    };
  },
  methods: {
    load(): void {
      this.task = repository.find(this.accountId);
      this.task.then((account: Account) => {
        this.account = account;
      });
    },
  },
  created(): void {
    this.load();
  },
  components: {
    AddClientBtn,
    UserSubscribedAccountsList,
    UserUnsubscribedAccountsList,
    InfoIcon,
  },
});
